import type { Product, SizeVariant } from "@/data/products";

/**
 * Build a customer-facing variant label that ALWAYS surfaces the size/volume
 * when one exists. Rules:
 *  - Size first ("100ml"), then the marketing label ("Best seller") if it adds
 *    information.
 *  - A label identical to the product name adds nothing, so it is dropped.
 *  - A label that already contains the size is used on its own.
 */
export const variantDisplayLabel = (
  variant: Pick<SizeVariant, "size" | "label" | "labelAr"> | null | undefined,
  isAr: boolean,
  product?: Pick<Product, "name" | "nameAr"> | null,
): string | null => {
  if (!variant) return null;
  const GENERIC = ["standard", "default", "one size", "regular", "عادي", "قياسي"];
  const rawSize = (variant.size || "").trim();
  const size = GENERIC.includes(rawSize.toLowerCase()) ? "" : rawSize;
  const rawName = ((isAr ? variant.labelAr || variant.label : variant.label || variant.labelAr) || "").trim();
  const productName = ((isAr ? product?.nameAr : product?.name) || "").trim().toLowerCase();
  const redundant = !!productName && (rawName.toLowerCase() === productName || productName.includes(rawName.toLowerCase()));
  const name = redundant ? "" : rawName;
  if (!size) return name || rawName || null;
  if (!name) return size;
  if (name.toLowerCase().includes(size.toLowerCase())) return name;
  return `${size} · ${name}`;
};
